




import {Vue, Component, Prop, Emit, Watch} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";
import {Vozilo} from "@/services/BackendProxies";
import {State} from "vuex-class";

@Component({})
export default class VoziloPripadnostEditor extends Vue {
    @Prop() value!: string;
    @Prop() parent!: string;
    @State vozila!: {id: string, text: string}[];
    @Prop({default: false}) invalid!: boolean;
    model = '';

    @Watch("value") onValueChange(value) {
        this.model = value;
    }

    @Watch("model") onModelChange(value) {
        this.input(value);
    }

    @Emit() input(value: string) {
    }

    async created() {
        this.model = this.value;
    }

    options = {
        templateResult: this.render,
        templateSelection: this.render
    };

     render(data: any) {
         if (data.kategorija == 1) {
             return $(`<p style="background: url(${'images/putnickoVoziloIcon.png'}) no-repeat left center; margin-bottom: 0; padding-left: 32px; background-size: 24px">${data.text}</p>`);
         } else if (data.kategorija == 2) {
             return $(`<p style="background: url(${'images/teretnoVoziloIcon.png'}) no-repeat left center; margin-bottom: 0; padding-left: 32px; background-size: 24px">${data.text}</p>`);
         } else if (data.kategorija == 3) {
             return $(`<p style="background: url(${'images/prikljucnoVoziloIcon.png'}) no-repeat left center; margin-bottom: 0; padding-left: 32px; background-size: 24px">${data.text}</p>`);
         } else if (data.kategorija == 4) {
             return $(`<p style="background: url(${'images/traktorIcon.png'}) no-repeat left center; margin-bottom: 0; padding-left: 32px; background-size: 24px">${data.text}</p>`);
         } else if (data.kategorija == 5) {
             return $(`<p style="background: url(${'images/busIcon.png'}) no-repeat left center; margin-bottom: 0; padding-left: 32px; background-size: 24px">${data.text}</p>`);
         } else if (data.kategorija == 6) {
             return $(`<p style="background: url(${'images/motorciklIcon.png'}) no-repeat left center; margin-bottom: 0; padding-left: 32px; background-size: 24px">${data.text}</p>`);
         } else {
             //return $(`<p>${data.text}</p>`);
             return $(`<p style="background: url(${'images/teretnoVoziloIcon.png'}) no-repeat left center; margin-bottom: 0; padding-left: 32px; background-size: 24px">${data.text}</p>`);
         }
    }
}
